/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as React from 'react';

export default class Alert extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            children: props.children,
            message: props.message
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            this.setState({ children: this.props.children });
        }
    }

    render() {
        var n = 0;
        return (<div className={'alert alert-' + (this.props.type ?? 'info') + (this.props.className ? ' ' + this.props.className : '')} onClick={this.props.onClick}>
            <FontAwesomeIcon icon={fa['fa' + (this.props.icon ?? 'InfoCircle')]} className="me-2" />
            {this.state.children ? (this.state.children.map ? this.state.children.map((obj) => (<span key={n++}>{obj}</span>)) : this.state.children) : this.state.message}
        </div >);
    }
}

